export const UPDATE_PAGE_HEADER: string = "UPDATE_PAGE_HEADER";

interface IHeader {
    header: string;
}

export const UpdatePageHeader = (data: IHeader) => {
    return { type: UPDATE_PAGE_HEADER, payload: data };
};